/*eslint-disable*/
export default {
    data() {
        return {
            classes: '',
            btn_id: null,
            paydata: null,
            sendingChoices: false,
            profile: null,
            loading: true,
            candidateCounselor: {},
            cycleId: null,
            days: [],
            selectedDays: [],
            selectedDaysList: [],
            remainCount: 0,
            unfitCounselor: '',
            unfitTime: '',
            todoMessage: '',
            showBuyPackage: false,
            canSelect: false,
            dialogRemainTime: false,
            dialogChangeCounselor: false,
            paymentDialog: false,
            successfulPayment: {
                refId: '',
                trCode: '',
            },
            nextSession: {},
            message: '',
            transactionClass: null,
            transactionRefId: null,
            validOrder: false,
            orderInfo: null,
        }
    },
    mounted() {
    },
    methods: {
        prepareDataForWebengageAndSend(resp) {
            this.orderInfo = resp.data
            if (resp.data.msg == "success payment") {
                let currency = resp.data.currency == 'dollar' ? 'USD' : 'RIAL';
                this.transactionMessage = this.successTitle;
                this.btn_id = 'ga_purchase_successful';
                // this.transactionClass = 'success';
                let order = resp.data.order;
                let conversionRate = resp.data.conversion_rate;
                this.successfulPayment.refId = resp.data.ref_id;


                if (resp.data.newCustomer) {
                    this.classes = 'new-customer';
                }
                // if (window.location.hostname.includes('simiaroom')) {

                let products = [];
                let webengageProducts = [];

                order.products.forEach((item, index) => {

                    webengageProducts[`product_id_${(index + 1)}`] = item.id;
                    webengageProducts[`product_name_${(index + 1)}`] = item.title;
                    webengageProducts[`product_discount_${(index + 1)}`] = parseFloat((item.pivot.discount * conversionRate).toFixed(2));
                    webengageProducts[`product_item_count_${(index + 1)}`] = item.pivot.quantity;
                    webengageProducts[`product_price_${(index + 1)}`] = parseFloat((item.pivot.price * conversionRate).toFixed(2));
                    webengageProducts[`product_session_count_${(index + 1)}`] = item.session_count;

                    products.push({
                        'name': item.title,
                        'id': item.id,
                        'price': item.pivot.price,
                        'brand': 'Simiaroom',
                        'category': 'Counseling',
                        'quantity': item.pivot.quantity
                    });
                });


                let ecommerce = {
                    purchase: {
                        actionField: {
                            id: resp.data.trCode,
                            revenue: order.subtotal //<%=sales.total%>
                        },
                        products
                    }
                }
                // console.log(ecommerce);
                if (order.discount == 0) {
                    ecommerce.purchase.actionField.coupon = '';
                } else {
                    ecommerce.purchase.actionField.coupon = order.discount;
                }
                let webEngageData = {
                    currency: 'dollar',
                    isFirstPurchase: (resp.data.newCustomer == true) ? 'new-customer' : 'old-customer',
                    cartsCount: resp.data.cartsCount,
                    cart_id: resp.data.payment.cart_id,
                    coupon_code: resp.data.coupon_code,
                    amount: parseFloat((resp.data.payment.cart_amount * conversionRate).toFixed(2)),
                    ...webengageProducts
                };


                //UNCOMMENT FOR PRODUCTION
                if (!resp.data.event_fired) {
                    this.sendWebEngagePaymentData('purchase', webEngageData);
                    if (resp.data.newCustomer) {
                        this.sendWebEngagePaymentData('first_purchase', webEngageData);
                    }

                    this.paydata = this.pushGa4PurchaseEvent(resp.data);
                }
                // this.transactionClass = 'green--text';
                // this.transactionRefId = resp.data.ref_id;
                // this.message = this.successTitle;
                this.validOrder = true;

            } else if (resp.data.msg == 'invalid payment') {
                // this.btn_id = 'ga_purchase_failed';
                //   this.transactionClass = 'red--text';
                //   this.transactionRefId = null;
                //   this.message = this.failedTitle;
                //   this.validOrder = false;
            }
        },
        sendWebEngagePaymentData(eventName, data) {
            // console.log(eventName, data, 'done');
            if (window.webengage) {
                window.webengage.track(eventName, data);
            }
        },
        toGa4CurrencyCode(rawCurrency) {
            const currency = String(rawCurrency || '').toLowerCase();
            if (currency === 'rial' || currency === 'irr') return 'IRR';
            if (currency === 'dollar' || currency === 'usd') return 'USD';
            if (currency === 'cad') return 'CAD';
            if (currency === 'aud') return 'AUD';
            if (currency === 'euro' || currency === 'eur') return 'EUR';
            if (currency === 'pound' || currency === 'gbp') return 'GBP';
            if (currency === 'try') return 'TRY';
            return String(rawCurrency || '').toUpperCase();
        },
        toNumericAmount(amount) {
            const value = Number(amount);
            return Number.isFinite(value) ? value : 0;
        },
        /**
         * GA4 purchase — only after backend confirms successful payment.
         * Uses the real paid amount and order currency (no hardcoded IRR).
         */
        pushGa4PurchaseEvent(data) {
            const order = data.order || {};
            const payment = data.payment || {};
            const cart = data.cart || {};
            const currency = this.toGa4CurrencyCode(data.currency || order.currency || payment.currency);

            const items = (order.products || []).map((item) => {
                const pivot = item.pivot || {};
                const unitPrice = pivot.final_price != null ? pivot.final_price : pivot.price;
                return {
                    item_id: String(item.id || ''),
                    item_name: item.title || item.en_title || '',
                    price: this.toNumericAmount(unitPrice),
                    quantity: Number(pivot.quantity) || 1,
                    transaction_type: item.transaction_type
                        || data.transaction_type
                        || cart.transaction_type
                        || '',
                };
            });

            const transactionId = data.trCode
                || payment.tr_code
                || payment.transaction_id
                || payment.id
                || order.id
                || cart.id;

            const paidValue = this.toNumericAmount(
                payment.paid_amount != null ? payment.paid_amount : order.subtotal
            );

            const purchasePayload = {
                event: 'purchase',
                ecommerce: {
                    transaction_id: String(transactionId || ''),
                    value: paidValue,
                    currency,
                    items,
                },
            };

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push(purchasePayload);

            return purchasePayload;
        },


    },
}